


































import {Component, Prop, Vue} from "vue-property-decorator";
import SelectSection from "@/components/users/SelectSection.vue";
import tokens from "@/authorization/tokens";

@Component({
    components:{
        SelectSection,
    }
})
export default class UserDisplay extends Vue {
    @Prop() public name!: string;
    @Prop() public kana!: string;
    @Prop() public phoneNumber!: string;
    @Prop() public email!: string;
    public accountId = tokens.AccountId;

}
